import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import './scss/FormInputCheckBoxTable.scss';
import get from 'lodash/get';
import { getValue } from '@syncfusion/ej2-base';
import { TooltipComponent } from '@syncfusion/ej2-react-popups';
import { Modal } from 'react-bootstrap';

interface IFormInputCheckboxTableProps {
    labels: string[];
    names: string[];
    disabled?: boolean;
    col?: number;
    title?: string;
    modal?: (string | null)[]; // nuevo: array de modales, puede contener texto o null
    required?: string | null; // mensaje de error si se requiere al menos uno de los checks de la lista marcados
}

const FormInputCheckboxTable: React.FC<IFormInputCheckboxTableProps> = ({
    labels,
    names,
    disabled = false,
    col = 12,
    title = "",
    required = null,
    modal = []
}) => {
    const { register, getValues, trigger, formState: { errors } } = useFormContext();
    const [showModalIndex, setShowModalIndex] = useState<number | null>(null);
    const validateGroup = () => {
        const checkValues = getValues(names);
        const isAnyChecked = checkValues?.some((val: boolean) => val === true);
        return isAnyChecked || required || true;
    };


    const errorMessage = get(errors, names[0])?.message;

    return (
        <div className="row">
            <label htmlFor="" className="input-block__label m-0 mb-1">
                {title}
            </label>

            {/* Mensaje de error del grupo de Checks */}
            {errorMessage && (
                <p data-input-name={names[0]} className="error m-0 mb-1" >
                    {errorMessage as any}
                </p>
            )}

            {labels.map((label, index) => {
                const name = names[index];
                const checkboxProps =
                    index === 0
                        ? register(name, { validate: validateGroup })
                        : register(name, { onChange: () => trigger(names[0]) });

                const hasModal = !!modal[index];
                return (
                    <div key={index} className={`col-12 col-md-${col} mb-2`}>
                        <div className="d-flex align-items-center justify-content-between position-relative w-100 checkbox-line-wrapper">
                            {/* Checkbox */}
                            <input
                                type="checkbox"
                                id={name}
                                {...checkboxProps}
                                disabled={disabled}
                                className="custom-checkbox"
                            />

                            {/* Línea gris dinámica */}
                            <div className="flex-grow-1 mx-1 separator-line"></div>

                            {/* Label */}
                            <div className='d-flex align-items-center checkbox-label-wrapper'>
                                {hasModal && (
                                    <TooltipComponent content="Más Información">
                                        <div
                                            onClick={() => setShowModalIndex(index)}
                                            className="information-icon-orange p-0 mr-2"
                                            style={{ cursor: 'pointer' }}
                                        />
                                    </TooltipComponent>
                                )}
                                <label
                                    htmlFor={name}
                                    className="m-0 label-text"
                                    style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
                                >
                                    {label}
                                </label>
                            </div>

                        </div>
                    </div>
                );
            })}

            <Modal size='lg'
                show={showModalIndex !== null}
                onHide={() => setShowModalIndex(null)}
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        {labels[showModalIndex ?? 0]}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {modal[showModalIndex ?? 0]}
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default FormInputCheckboxTable;
